if ( typeof ProductImageZoom !== 'function' ) {

	const ZOOM_SCALE_STEPS = [1, 1.25, 1.5, 1.75, 2, 2.5, 3];

	const ZOOM_ICON_PREV = `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.273 15.089 1.011 7.892l1.362-1.35 7.262 7.197-1.362 1.35Z" fill="currentColor"/><path d="M9.637 2.067 2.363 9.253.999 7.906 8.273.72l1.364 1.347Z" fill="currentColor"/></svg>`;
	const ZOOM_ICON_NEXT = `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.727 15.089 8.989 7.892 7.627 6.542.365 13.739 1.727 15.089Z" fill="currentColor"/><path d="M0.363 2.067 7.637 9.253 9.001 7.906 1.727.72.363 2.067Z" fill="currentColor"/></svg>`;
	class ProductImageZoomView {

		constructor() {
			this.el = null;
			this.image = null;
			this.scaleIndex = 0;
			this.pinchMultiplier = 1;
			this.baseWidth = 0;
			this.baseHeight = 0;
			this.bodyOverflow = '';
			this.isOpen = false;
			this.slides = [];
			this.slideIndex = 0;
			this.isPinching = false;
			this.pinchStartDistance = 0;
			this.pinchStartScale = 1;
			this.swipeStart = null;

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);
			this.onKeyDownHandlerBinded = this.onKeyDownHandler.bind(this);
			this.onViewportClickHandlerBinded = this.onViewportClickHandler.bind(this);
			this.onTouchStartHandlerBinded = this.onTouchStartHandler.bind(this);
			this.onTouchMoveHandlerBinded = this.onTouchMoveHandler.bind(this);
			this.onTouchEndHandlerBinded = this.onTouchEndHandler.bind(this);
		}

		init() {
			if ( this.el ) {
				return;
			}

			const symbols = typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.symbols
				? KROWN.settings.symbols
				: { zoom_in: '+', zoom_out: '−', close: '×', zoom_loader: '' };

			this.el = document.createElement('div');
			this.el.id = 'zoom';
			this.el.setAttribute('role', 'dialog');
			this.el.setAttribute('aria-modal', 'true');
			this.el.setAttribute('aria-hidden', 'true');
			this.el.innerHTML = `
				<div class="zoom__overlay" data-zoom-dismiss></div>
				<img alt="" />
				<div class="zoom__toolbar element--has-border--body element--border-radius">
					<div class="zoom__toolbar-group zoom__toolbar-group--nav">
						<button type="button" class="zoom__control zoom__control--prev" aria-label="Önceki görsel">${ZOOM_ICON_PREV}</button>
						<span class="zoom__counter" aria-live="polite">1 / 1</span>
						<button type="button" class="zoom__control zoom__control--next" aria-label="Sonraki görsel">${ZOOM_ICON_NEXT}</button>
					</div>
					<span class="zoom__toolbar-divider zoom__toolbar-divider--nav" aria-hidden="true"></span>
					<div class="zoom__toolbar-group zoom__toolbar-group--zoom">
						<button type="button" class="zoom__control zoom__control--out" aria-label="Uzaklaştır">${symbols.zoom_out}</button>
						<span class="zoom__level" aria-live="polite">100%</span>
						<button type="button" class="zoom__control zoom__control--in" aria-label="Yakınlaştır">${symbols.zoom_in}</button>
					</div>
					<span class="zoom__toolbar-divider zoom__toolbar-divider--close" aria-hidden="true"></span>
					<button type="button" class="zoom__control zoom__control--close" aria-label="Kapat">${symbols.close}</button>
				</div>
				<span class="zoom__loader">${symbols.zoom_loader}</span>
			`;
			document.body.append(this.el);

			this.image = this.el.querySelector('img');
			this.btnOut = this.el.querySelector('.zoom__control--out');
			this.btnIn = this.el.querySelector('.zoom__control--in');
			this.btnClose = this.el.querySelector('.zoom__control--close');
			this.btnPrev = this.el.querySelector('.zoom__control--prev');
			this.btnNext = this.el.querySelector('.zoom__control--next');
			this.levelEl = this.el.querySelector('.zoom__level');
			this.counterEl = this.el.querySelector('.zoom__counter');
			this.navGroup = this.el.querySelector('.zoom__toolbar-group--nav');
			this.navDivider = this.el.querySelector('.zoom__toolbar-divider--nav');

			this.btnClose.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.close();
			});
			this.btnIn.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.zoomIn();
			});
			this.btnOut.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.zoomOut();
			});
			this.btnPrev.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.goToSlide(-1);
			});
			this.btnNext.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.goToSlide(1);
			});
			this.el.addEventListener('click', this.onViewportClickHandlerBinded);
			this.el.addEventListener('touchstart', this.onTouchStartHandlerBinded, { passive: true });
			this.el.addEventListener('touchmove', this.onTouchMoveHandlerBinded, { passive: false });
			this.el.addEventListener('touchend', this.onTouchEndHandlerBinded, { passive: true });
			this.el.addEventListener('touchcancel', this.onTouchEndHandlerBinded, { passive: true });
		}

		open(trigger) {
			this.init();
			this.slides = ProductImageZoom.collectSlides(trigger);
			this.slideIndex = Math.max(0, this.slides.findIndex((slide) => slide.el === trigger));
			if ( this.slideIndex < 0 ) {
				this.slideIndex = 0;
			}

			this.scaleIndex = 0;
			this.pinchMultiplier = 1;
			this.isOpen = true;
			this.el.setAttribute('aria-hidden', 'false');
			this.el.classList.add('opened');
			this.bodyOverflow = document.body.style.overflow;
			document.body.style.overflow = 'hidden';

			this.updateNavControls();
			this.loadSlide(this.slides[this.slideIndex].src);
		}

		loadSlide(imageSrc) {
			this.el.classList.remove('loaded');
			this.image.onload = null;
			this.image.src = imageSrc;
			if ( this.image.naturalWidth > 0 ) {
				this.mount();
			} else {
				this.image.onload = () => {
					this.image.onload = null;
					this.mount();
				};
			}
		}

		close() {
			if ( !this.isOpen || !this.el ) {
				return;
			}

			this.isOpen = false;
			this.isPinching = false;
			this.swipeStart = null;
			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			document.removeEventListener('keydown', this.onKeyDownHandlerBinded);

			this.el.classList.remove('opened');
			this.el.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = this.bodyOverflow;

			setTimeout(() => {
				if ( this.image ) {
					this.image.src = '';
					this.image.className = '';
					this.image.removeAttribute('style');
					this.image.alt = '';
				}
				this.el.classList.remove('loaded');
				this.scaleIndex = 0;
				this.pinchMultiplier = 1;
				this.slides = [];
				this.slideIndex = 0;
			}, 300);
		}

		mount() {
			this.image.style.left = '0';
			this.image.style.top = '0';

			const ratio = this.image.naturalWidth / this.image.naturalHeight;
			this.image.dataset.ratio = ratio;
			if ( ratio < 1 ) {
				this.image.classList.add('portrait');
			} else {
				this.image.classList.remove('portrait');
			}

			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			document.removeEventListener('keydown', this.onKeyDownHandlerBinded);

			window.addEventListener('resize', this.onResizeHandlerBinded, { passive: true });
			document.addEventListener('keydown', this.onKeyDownHandlerBinded);

			if ( !this.isTouchDevice() ) {
				window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, { passive: true });
			}

			this.updateBaseDimensions();
			this.applyScale();
			this.updateZoomButtons();
			this.updateNavControls();

			setTimeout(() => {
				this.centerScrollOnTouch();
				this.el.classList.add('loaded');
				this.btnClose.focus({ preventScroll: true });
			}, 50);
		}

		isTouchDevice() {
			return document.body.classList.contains('touch') || document.body.classList.contains('touchevents');
		}

		onKeyDownHandler(e) {
			if ( !this.isOpen ) {
				return;
			}

			if ( e.key === 'Escape' ) {
				e.preventDefault();
				this.close();
				return;
			}

			if ( e.key === 'ArrowLeft' ) {
				e.preventDefault();
				this.goToSlide(-1);
				return;
			}

			if ( e.key === 'ArrowRight' ) {
				e.preventDefault();
				this.goToSlide(1);
				return;
			}

			if ( e.key === '+' || e.key === '=' ) {
				e.preventDefault();
				this.zoomIn();
				return;
			}

			if ( e.key === '-' || e.key === '_' ) {
				e.preventDefault();
				this.zoomOut();
			}
		}

		onViewportClickHandler(e) {
			if ( e.target.closest('.zoom__toolbar') || e.target.closest('img') ) {
				return;
			}
			if ( e.target.hasAttribute('data-zoom-dismiss') || e.target === this.el ) {
				this.close();
			}
		}

		onMouseMoveHandler(e) {
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			this.updatePanPosition(e.clientX, e.clientY);
		}

		onResizeHandler() {
			this.updateBaseDimensions();
			this.applyScale();
		}

		onTouchStartHandler(e) {
			if ( !this.isOpen ) {
				return;
			}

			if ( e.touches.length === 2 ) {
				this.isPinching = true;
				this.pinchStartDistance = this.getTouchDistance(e.touches);
				this.pinchStartScale = this.getEffectiveScale();
				this.swipeStart = null;
				return;
			}

			if ( e.touches.length === 1 ) {
				this.swipeStart = {
					x: e.touches[0].clientX,
					y: e.touches[0].clientY
				};
			}
		}

		onTouchMoveHandler(e) {
			if ( !this.isOpen || !this.isPinching || e.touches.length !== 2 ) {
				return;
			}

			e.preventDefault();
			const distance = this.getTouchDistance(e.touches);
			if ( !this.pinchStartDistance ) {
				return;
			}

			const ratio = distance / this.pinchStartDistance;
			const targetScale = this.clampScale(this.pinchStartScale * ratio);
			this.pinchMultiplier = targetScale / ZOOM_SCALE_STEPS[this.scaleIndex];
			this.applyScale(false);
			this.updateLevelDisplay();
		}

		onTouchEndHandler(e) {
			if ( this.isPinching && (e.touches.length < 2 || e.type === 'touchend') ) {
				this.isPinching = false;
				this.snapPinchToStep();
			}

			if ( !this.swipeStart || e.changedTouches.length !== 1 || this.getEffectiveScale() > 1.01 ) {
				this.swipeStart = null;
				return;
			}

			const touch = e.changedTouches[0];
			const deltaX = touch.clientX - this.swipeStart.x;
			const deltaY = touch.clientY - this.swipeStart.y;

			if ( Math.abs(deltaX) > 56 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2 ) {
				this.goToSlide(deltaX > 0 ? -1 : 1);
			}

			this.swipeStart = null;
		}

		getTouchDistance(touches) {
			const dx = touches[0].clientX - touches[1].clientX;
			const dy = touches[0].clientY - touches[1].clientY;
			return Math.hypot(dx, dy);
		}

		clampScale(scale) {
			return Math.min(ZOOM_SCALE_STEPS[ZOOM_SCALE_STEPS.length - 1], Math.max(ZOOM_SCALE_STEPS[0], scale));
		}

		snapPinchToStep() {
			const effective = this.getEffectiveScale();
			let nearestIndex = 0;
			let nearestDiff = Infinity;

			for ( let i = 0; i < ZOOM_SCALE_STEPS.length; i += 1 ) {
				const diff = Math.abs(ZOOM_SCALE_STEPS[i] - effective);
				if ( diff < nearestDiff ) {
					nearestDiff = diff;
					nearestIndex = i;
				}
			}

			this.scaleIndex = nearestIndex;
			this.pinchMultiplier = 1;
			this.applyScale();
			this.updateZoomButtons();
			this.centerScrollOnTouch();
		}

		getEffectiveScale() {
			return ZOOM_SCALE_STEPS[this.scaleIndex] * this.pinchMultiplier;
		}

		updateBaseDimensions() {
			const rf = window.innerWidth > 768 ? 1 : 2;

			if ( this.image.classList.contains('portrait') ) {
				this.baseWidth = window.innerWidth * rf;
				this.baseHeight = this.baseWidth / this.image.dataset.ratio;
			} else {
				this.baseHeight = window.innerHeight * rf;
				this.baseWidth = this.baseHeight * this.image.dataset.ratio;

				if ( this.baseWidth < window.innerWidth ) {
					this.baseWidth = window.innerWidth * rf;
					this.baseHeight = this.baseWidth / this.image.dataset.ratio;
				}
			}
		}

		applyScale(updatePan = true) {
			const scale = this.getEffectiveScale();
			const width = this.baseWidth * scale;
			const height = this.baseHeight * scale;

			this.image.style.width = width + 'px';
			this.image.style.height = height + 'px';

			if ( updatePan && !this.isTouchDevice() ) {
				const clientX = typeof window.clientX === 'number' ? window.clientX : window.innerWidth / 2;
				const clientY = typeof window.clientY === 'number' ? window.clientY : window.innerHeight / 2;
				this.updatePanPosition(clientX, clientY);
			}
		}

		updatePanPosition(clientX, clientY) {
			if ( this.isTouchDevice() ) {
				return;
			}

			const x = clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		centerScrollOnTouch() {
			if ( !this.isTouchDevice() || !this.el ) {
				return;
			}

			this.el.scrollLeft = Math.max(0, ( this.image.offsetWidth - window.innerWidth ) / 2);
			this.el.scrollTop = Math.max(0, ( this.image.offsetHeight - window.innerHeight ) / 2);
		}

		goToSlide(delta) {
			if ( this.slides.length <= 1 ) {
				return;
			}

			const nextIndex = this.slideIndex + delta;
			if ( nextIndex < 0 || nextIndex >= this.slides.length ) {
				return;
			}

			this.slideIndex = nextIndex;
			this.scaleIndex = 0;
			this.pinchMultiplier = 1;
			this.updateNavControls();
			this.loadSlide(this.slides[this.slideIndex].src);
		}

		zoomIn() {
			if ( this.scaleIndex >= ZOOM_SCALE_STEPS.length - 1 ) {
				return;
			}
			this.pinchMultiplier = 1;
			this.scaleIndex += 1;
			this.applyScale();
			this.updateZoomButtons();
			this.centerScrollOnTouch();
		}

		zoomOut() {
			if ( this.scaleIndex <= 0 && this.pinchMultiplier <= 1 ) {
				return;
			}
			this.pinchMultiplier = 1;
			if ( this.scaleIndex <= 0 ) {
				return;
			}
			this.scaleIndex -= 1;
			this.applyScale();
			this.updateZoomButtons();
			this.centerScrollOnTouch();
		}

		updateLevelDisplay() {
			if ( !this.levelEl ) {
				return;
			}
			this.levelEl.textContent = `${Math.round(this.getEffectiveScale() * 100)}%`;
		}

		updateZoomButtons() {
			if ( this.btnIn ) {
				this.btnIn.disabled = this.getEffectiveScale() >= ZOOM_SCALE_STEPS[ZOOM_SCALE_STEPS.length - 1] - 0.001;
			}
			if ( this.btnOut ) {
				this.btnOut.disabled = this.scaleIndex <= 0 && this.pinchMultiplier <= 1;
			}
			this.updateLevelDisplay();
		}

		updateNavControls() {
			const hasMultiple = this.slides.length > 1;

			if ( this.navGroup ) {
				this.navGroup.hidden = !hasMultiple;
			}
			if ( this.navDivider ) {
				this.navDivider.hidden = !hasMultiple;
			}
			if ( this.btnPrev ) {
				this.btnPrev.disabled = !hasMultiple || this.slideIndex <= 0;
			}
			if ( this.btnNext ) {
				this.btnNext.disabled = !hasMultiple || this.slideIndex >= this.slides.length - 1;
			}
			if ( this.counterEl ) {
				this.counterEl.textContent = `${this.slideIndex + 1} / ${Math.max(this.slides.length, 1)}`;
			}
		}

	}

	const productImageZoomView = new ProductImageZoomView();

	class ProductImageZoom extends HTMLElement {

		static collectSlides(trigger) {
			const gallery = trigger.closest('[data-js-product-gallery]');
			if ( !gallery ) {
				return [{
					el: trigger,
					src: trigger.getAttribute('data-image'),
					index: parseInt(trigger.getAttribute('data-index') || '0', 10)
				}];
			}

			const zoomTriggers = gallery.querySelectorAll('product-image-zoom[data-image]');
			return Array.from(zoomTriggers).map((el) => ({
				el,
				src: el.getAttribute('data-image'),
				index: parseInt(el.getAttribute('data-index') || '0', 10)
			})).sort((a, b) => a.index - b.index);
		}

		constructor() {
			super();
			this.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				if ( !this.getAttribute('data-image') ) {
					return;
				}
				productImageZoomView.open(this);
			});
		}

	}

	if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
